import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const Container = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  min-height: 0;
  ${props =>
    props.$fill
      ? `
    flex: 1;
    max-height: none;
    height: 100%;
    overflow: hidden;
  `
      : `
    max-height: 500px;
    overflow: auto;
  `}
`;

const Title = styled(Typography)`
  padding: 20px;
  flex-shrink: 0;
`;

const TitleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 20px;
  flex-shrink: 0;
  background: transparent;
  border: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.color.primary.light};
    color: ${({ theme }) => theme.color.primary.dark};
  }

  .wui-widget-chevron {
    font-size: 20px;
    color: #b2b2b2;
    transition: transform 0.15s ease, color 0.15s ease;
  }
  &:hover .wui-widget-chevron,
  &:focus-visible .wui-widget-chevron {
    color: ${({ theme }) => theme.color.primary.dark};
    transform: translateX(2px);
  }
`;

const Body = styled.div`
  ${props =>
    props.$fill
      ? `
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  `
      : ""}
`;

const Widget = props => {
  const { title, children, fill, onTitleClick } = props;
  const titleContent = (
    <Typography variant="subtitle2" component="span">
      {title}
    </Typography>
  );

  return (
    <Container $fill={fill}>
      {onTitleClick ? (
        <TitleButton
          type="button"
          onClick={onTitleClick}
          aria-label={`${title} — abrir`}
        >
          {titleContent}
          <ChevronRightIcon className="wui-widget-chevron" />
        </TitleButton>
      ) : (
        <Title variant="subtitle2">{title}</Title>
      )}
      <Body $fill={fill}>{children}</Body>
    </Container>
  );
};

Widget.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fill: PropTypes.bool,
  onTitleClick: PropTypes.func
};

Widget.defaultProps = {
  fill: false,
  onTitleClick: null
};

export default Widget;
